<template>
  <div class="text-textColor overflow-hidden">
    <transition name="fade">
      <div
        v-if="showReviewTraining"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full overflow-hidden"
      >
        <div
          class="fixed overflow-y-auto max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-3/5 w-full p-2"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <div
            class="flex justify-between items-center border-b-1.5 font-bold pb-2"
          >
            <p class="text-base">Leave Details</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>

          <div class="grid grid-cols-1 md:grid-cols-3 px-0.5 py-2 gap-5 mb-3">
            <div class="text-sm">
              <label class="block pb-1">Leave Type</label>
              <input
                :value="leaveDetails.LeaveType"
                type="text"
                disabled
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Leave Span</label>
              <input
                :value="leaveDetails.LeaveSpan"
                type="text"
                disabled
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Period</label>
              <input
                :value="leaveDetails.Period"
                type="text"
                disabled
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Start Date</label>
              <input
                :value="formatDate(leaveDetails.StartDate)"
                disabled
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">End Date</label>
              <input
                :value="formatDate(leaveDetails.EndDate)"
                disabled
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Status</label>
              <input
                :value="leaveDetails.Status"
                type="text"
                disabled
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm col-span-3">
              <label class="block pb-1">Attachments</label>
              <div
                class="flex gap-2 p-2 py-3 bg-gray-200 rounded-md w-full border-1.5"
              >
                <button
                  v-if="attachmentUrl.trim().length"
                  @click="viewAttachment(attachmentUrl)"
                  class="bg-primary text-white rounded-full px-3 py-1 text-sm"
                >
                  &#128206; View
                </button>
                <p v-if="attachmentUrl.trim().length === 0">
                  No attachments found
                </p>
              </div>
            </div>
          </div>

          <ve-table
            rowKeyFieldName="Id"
            :fixed-header="true"
            :columns="columns"
            :table-data="approvalEntries"
          />
          <p
            v-if="approvalEntries.length == 0 && !loading && !get_error"
            class="p-1 text-center text-sm w-full bg-gray-100"
          >
            No workflows found
          </p>
        </div>
      </div>
    </transition>

    <attachments-viewer
      :attachmentUrl="currentAttachment"
      :attachmentType="attachmentType"
      :show-attachments="showAttachments"
      @close="showAttachments = false"
      :approval="[]"
    ></attachments-viewer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import AttachmentsViewer from "../../utils/attachmentsViewer.vue";
import axios from "axios";

export default {
  name: "ReviewTraining",
  props: [
    "showReviewTraining",
    "workflowToReview",
    "leaveDetails",
    "approvalEntries",
    "attachmentUrl",
  ],
  components: {
    Loader,
    AttachmentsViewer,
  },
  data() {
    return {
      locations: [], // add locations data
      reason: "",
      loading: false,
      // locations: null,
      departments: null,
      isEditing: false,
      create_success: null,
      create_error: null,
      employees: null,
      currentAttachment: null,
      showAttachments: false,
      attachmentType: "",
      columns: [
        {
          field: "",
          key: "a",
          title: "#",
          width: 50,
          align: "left",

          operationColumn: true,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            row, column, h;
            return ++rowIndex;
          },
        },
        {
          field: "Approver",
          key: "Approver",
          title: "Approver",
          align: "left",
          edit: true,
        },

        {
          field: "Sequence",
          key: "sequence",
          title: "Sequence",
          align: "center",
          headerAlign: "right",
          edit: true,
        },
        {
          field: "Status",
          key: "Status",
          title: "Status",
          align: "center",
          headerAlign: "right",
          edit: true,

          renderBodyCell: ({ row }) => {
            return row.Status === "Approved" ? (
              <p class="text-green-500">{row.Status}</p>
            ) : (
              <p class="text-yellow-500">{row.Status}</p>
            );
          },
        },
      ],
      // table data
      tableData: [
        {
          Fullname: "",
          Sequence: null,
          Id: null,
        },
      ],
    };
  },

  computed: {
    ...mapGetters(["getOrganization", "getBase", "getToken"]),
  },
  methods: {
    close() {
      this.$emit("close");
    },

    created() {
      this.getEmployees();
      this.getLocations();
    },

    formatDate(dateStr) {
      const date = new Date(dateStr);
      const options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      };
      return date.toLocaleDateString("en-US", options);
    },

    viewAttachment(documentUrl) {
      const config = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        responseType: "arraybuffer", // Include the responseType option in the config object
      };

      this.attachmentType = documentUrl;
      axios
        .get(documentUrl, config) // Pass the config object as the second argument
        .then((response) => {
          if (response.status === 200) {
            // Create a Blob from the response data
            const blob = new Blob([response.data], { type: "*" });

            // Create a URL for the Blob
            const url = URL.createObjectURL(blob);
            this.showAttachments = true;
            this.currentAttachment = url;
          } else {
            this.get_error = response.data.StatusMessage;
            setTimeout(() => {
              this.get_error = null;
            }, 2500);
          }
        })
        .catch((error) => {
          this.get_error = error;
          setTimeout(() => {
            this.get_error = null;
          }, 2500);
        });
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
